<template>
  <div
    class="coupon-card"
    :class="{
      'expiring-soon': !disabled && value.nearlyExpired == 1,
      disabled: disabled,
    }"
  >
    <div class="coupon-card-left">
      <div class="coupon-value">{{ value.productAmountYuan }}元</div>
      <div class="coupon-condition">{{ value.remark }}</div>
    </div>
    <div class="coupon-card-right">
      <div class="coupon-card-info">
        <div class="coupon-provider">
          <img
            class="coupon-provider-icon"
            :src="providerLogo"
          >
          <span>{{ value.providerCompanyName }}</span>
        </div>
        <div class="coupon-deadline">{{ value.validEndDate }}过期</div>
      </div>
      <div
        v-if="!disabled"
        class="coupon-card-btn"
        @click="handleToUseClick"
      >
        去使用
      </div>
    </div>
  </div>
</template>

<script>
import LogoTELD from '@/assets/img/chargingVoucher/logo-tld.png';
import LogoXJCD from '@/assets/img/chargingVoucher/logo-xjcd.png';
import IconXXCD from '@/assets/img/chargingVoucher/logo-xxcd.png';

export default {
  name: 'CouponCard',
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    providerLogo() {
      if (this.value.providerCompanyNo === 'XIAOJU') {
        return LogoXJCD;
      }
      if (this.value.providerCompanyNo === 'TELD') {
        return LogoTELD;
      }
      if (this.value.providerCompanyNo === 'STARCHARGE') {
        return IconXXCD;
      }
      return LogoTELD;
    }
  },
  methods: {
    handleToUseClick() {
      const url = '/pages/extend/middle';
      let miniProgramKey = '';
      const miniProgramKeyOb = {
        TELD: 'tld',
        XIAOJU: 'xjcd',
        STARCHARGE: 'xxcd'
      };
      miniProgramKey = miniProgramKeyOb[this.value.providerCompanyNo] || '';
      wx.miniProgram.navigateTo({
        url: `${url}?type=toMiniProgram&miniProgramKey=${miniProgramKey}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-card {
  box-sizing : border-box;
  width : 100%;
  height : 180px;
  margin-bottom : 16px;
  background : #FFFFFF;
  border-radius : 20px;
  display : flex;
  align-items : center;
  position : relative;

  &.disabled {
    .coupon-card-left {
      .coupon-value {
        color : #787878 !important;
      }
      .coupon-condition {
        color : #787878 !important;
      }
    }
    .coupon-card-right {
      .coupon-card-info {
        .coupon-provider {
          color : #787878 !important;
        }
      }
    }
  }
  .coupon-card-left {
    display : flex;
    flex-direction : column;
    justify-content : center;
    width : 200px;
    box-sizing : border-box;
    border-right : 1px dashed rgba(200, 200, 200, 1);
    height : 100%;

    .coupon-value {
      text-align : center;
      font-size : 42px;
      color : #FF722C;
      font-weight : bold;
      line-height : 67px;
      margin-bottom : 4px;
      white-space : nowrap;
    }
    .coupon-condition {
      text-align : center;
      font-size : 24px;
      color : #FF722C;
      letter-spacing : .36px;
      font-weight : 400;
    }
  }
  .coupon-card-right {
    flex : 1;
    display : flex;
    align-items : center;
    justify-content : space-between;
    box-sizing : border-box;
    padding : 24px;
    height : 100%;
    flex-shrink : 0;

    .coupon-card-info {
      flex : 1;

      .coupon-provider {
        font-size : 32px;
        color : #383838;
        font-weight : 400;
        margin-bottom : 19px;
        display : flex;
        align-items : center;

        .coupon-provider-icon {
          width : 48px;
          height : 48px;
          object-fit : contain;
          margin-right : 4px;
        }
      }
      .coupon-deadline {
        font-size : 24px;
        color : #999999;
        letter-spacing : .36px;
        font-weight : 400;
      }
    }
    .coupon-card-btn {
      width : 120px;
      height : 56px;
      background : #FF722C;
      border-radius : 28px;
      font-size : 24px;
      color : #FFFFFF;
      letter-spacing : .36px;
      font-weight : 400;
      display : flex;
      align-items : center;
      justify-content : center;
      flex-shrink : 0;
    }
  }
  &.expiring-soon::after {
    content : '即将过期';
    position : absolute;
    right : 0px;
    top : 0px;
    font-size : 24px;
    color : #1F5AE5;
    font-weight : bold;
    background : #D4DCFF;
    border-radius : 0px 20px 0px 20px;
    width : 110px;
    height : 40px;
    display : flex;
    align-items : center;
    justify-content : center;
  }
}

</style>
